import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appFooterHeight]',
  standalone: true
})
export class FooterHeightDirective implements AfterViewInit {
  constructor(
    private elRef: ElementRef<HTMLElement>,
  ) {}

  ngAfterViewInit(): void {
    const pageEl = document.querySelector<HTMLElement>(".page");

    if(!pageEl){return}

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const visibleHeight = entry.intersectionRect.height;
        pageEl.style.setProperty("--footer-height", visibleHeight + 'px');
      });
    }, {
      threshold: Array.from({ length: 20 }, (_, i) => i * 0.05) // Пороги срабатывания
    });

    observer.observe(this.elRef.nativeElement)
  }
}

